import React from "react";
import type { DetailData } from "../../../../../contexts/chat-log/chat-log-context";
import { useChatbotConfig } from "../../../../../contexts/chatbot-config";
import { isDirectNavigationLink } from "../../../../../libs/fns";
import AssetCard from "./asset-card";

export default function CtaDetailData({
  file_path,
  file_name,
  text,
  asset_title,
  fullWidth,
}: Pick<DetailData, "file_path" | "file_name" | "text" | "asset_title"> & { fullWidth?: boolean }) {
  const { chatbotData } = useChatbotConfig();
  const baseUrl = chatbotData?.chatbot_S3_URL || "";
  const [lightboxUrl, setLightboxUrl] = React.useState<string | null>(null);

  const ctaPaths = file_path.split(',').map((p) => p.trim()).filter(Boolean);
  const ctaUrls = (text || '').split(',').map((u) => u.trim());

  React.useEffect(() => {
    if (!lightboxUrl) return;
    const handler = (e: KeyboardEvent) => {
      if (e.key === "Escape") setLightboxUrl(null);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [lightboxUrl]);

  const handleClick = (imgSrc: string, linkUrl: string) => {
    if (isDirectNavigationLink(linkUrl)) {
      window.location.href = linkUrl;
    } else if (linkUrl) {
      window.open(linkUrl, '_blank', 'noopener,noreferrer');
    } else {
      setLightboxUrl(imgSrc);
    }
  };

  return (
    <>
      {lightboxUrl && (
        <div
          onClick={() => setLightboxUrl(null)}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(0,0,0,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            onClick={(e) => { e.stopPropagation(); setLightboxUrl(null); }}
            style={{
              position: "absolute",
              top: "16px",
              right: "16px",
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: "rgba(255,255,255,0.15)",
              border: "2px solid rgba(255,255,255,0.6)",
              color: "#fff",
              fontSize: "18px",
              fontWeight: "bold",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              backdropFilter: "blur(4px)",
            }}
            aria-label="閉じる"
          >
            ×
          </button>
          <img
            src={lightboxUrl}
            alt={file_name}
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "90vw",
              maxHeight: "90vh",
              objectFit: "contain",
              borderRadius: "12px",
              boxShadow: "0 8px 40px rgba(0,0,0,0.5)",
            }}
          />
        </div>
      )}
      <div style={{ display: 'flex', flexShrink: 0, gap: '8px', overflowX: 'auto', padding: '4px 0' }}>
        {ctaPaths.map((path, index) => {
          const imgSrc = path.startsWith('http') ? path : `${baseUrl}/${path}`;
          const linkUrl = ctaUrls[index] || '';
          return (
            <AssetCard
              key={index}
              thumbnailUrl={imgSrc}
              alt={file_name}
              title={asset_title || undefined}
              onButtonClick={() => handleClick(imgSrc, linkUrl)}
              fullWidth={fullWidth}
            />
          );
        })}
      </div>
    </>
  );
}
